import React from 'react';
import PropTypes from 'prop-types';
import { orderBy } from 'lodash/orderBy';
import uniqBy from 'lodash/uniqBy';
import { icons } from 'smartsuite-ui/lib/constants/icons';
import DashboardViewTitle from './DashboardViewTitle';

export default function LibraryDashboardsView(props) {
    const dashboardViews = props.availableWidgets.map((widget) => ({
        dashboardKey: widget.dashboardKey,
        dashboardTitle: widget.dashboardTitle,
        viewKey: widget.viewKey,
        viewTitle: widget.viewTitle,
    }));

    const className = props.isCurrentView
        ? 'widget-library__dashboard-view'
        : 'widget-library__dashboard-view widget-library__dashboard-view--closed';

    return (
        <div className={className}>
            {orderBy(uniqBy(dashboardViews, JSON.stringify), [
                'dashboardTitle',
                'viewTitle',
            ]).map((dashboardView) => (
                <button
                    type="button"
                    key={`${dashboardView.dashboardKey}-${dashboardView.viewKey}`}
                    className="widget-library__dashboard"
                    onClick={() => props.onDashboardSelect(dashboardView)}
                >
                    <div className="widget-library__dashboard-title">
                        <DashboardViewTitle
                            dashboardTitle={dashboardView.dashboardTitle}
                            viewKey={dashboardView.viewKey}
                            viewTitle={dashboardView.viewTitle}
                        />
                    </div>
                    <div className="widget-library__dashboard-chevron">
                        <span className={icons.chevronRight} />
                    </div>
                </button>
            ))}
        </div>
    );
}

LibraryDashboardsView.propTypes = {
    availableWidgets: PropTypes.instanceOf(Array).isRequired,
    isCurrentView: PropTypes.bool.isRequired,
    onDashboardSelect: PropTypes.func.isRequired,
};
